// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_tJt","tabsBox":"styles_tabsBox__2CbIU","createButton":"styles_createButton__1yt7Z"};